<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <div class="pull-left">
                                    <h4 class="card-title float-left" v-if="realEstate.id">
                                        {{$t("realEstate.edit.title")}}
                                        ({{$t(realEstate.category === 'Residential' ?
                                        'realEstate.category.residential.label' :
                                        'realEstate.category.notorious.label')}})</h4>
                                    <h4 class="card-title float-left" v-else>{{$t("realEstate.add.title")}}
                                        ({{$t(realEstate.category === 'Residential' ?
                                        'realEstate.category.residential.label' :
                                        'realEstate.category.notorious.label')}})</h4>
                                </div>
                                <button class="all-btn pull-right" @click="headerAction('coordination')">
                                    Мувофиқлаштириш
                                </button>
                                <button class="all-btn add-btn pull-right mr-3" v-if="realEstate.landComparisonEnabled && !realEstate.approachRegression"
                                        @click="headerAction('land')">Ер участкасини хисоблаш
                                </button>
                            </div>
                        </div>
                        <div class="row" v-if="realEstate.status === 'Rejected'">
                            <div class="col">
                                <div class="alert alert-danger">
                                    <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган..
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationRespectiveType")}} <span
                                            class="red">*</span></label>
                                    <select class="form-control" v-model="realEstate.evaluationRespectiveType"
                                            :class="{invalid : $v.realEstate.evaluationRespectiveType.$error}">
                                        <option :value="option.code" v-for="option in evaluationRespectiveTypes" :key="option.code">
                                            {{option.displayName}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.realEstate.evlGoalType.$error">
                                        {{$t("realEstate.validation.evaluationRespectiveType")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.ownerClient")}} <span class="red">*</span></label>
                                    <v-select v-model="realEstate.owner" label="text"
                                              :options="owners"
                                              :filterable="false"
                                              @search="onOwnerSearch"
                                              @search:focus="onOwnerFocus"
                                              :disabled="!!realEstate.id"
                                              :class="{invalid : $v.realEstate.owner.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="realEstate && realEstate.owner && realEstate.owner.text">
                                            <div v-html="realEstate.owner.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.realEstate.owner.$error">
                                        {{$t("realEstate.validation.ownerClient")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-check pl-0">
                                        <label class="form-check-label" style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="realEstate.hasCustomer">
                                            <span class="form-check-sign"></span>
                                            {{$t("realEstate.field.withLetterOfAttorney")}}
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group" v-if="realEstate.hasCustomer">
                                    <label>{{$t("realEstate.field.withLetterOfAttorneyOwner")}} <span
                                            class="red">*</span></label>
                                    <v-select v-model="realEstate.customer" label="text"
                                              :options="customers"
                                              :filterable="false"
                                              @search="onCustomerSearch"
                                              @search:focus="onCustomerFocus"
                                              :class="{invalid : $v.realEstate.customer.$error}">
                                        <template slot="option" slot-scope="option" v-if="option && option.text">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="realEstate && realEstate.customer && realEstate.customer.text">
                                            <div v-html="realEstate.customer.text"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.realEstate.customer.$error">
                                        {{$t("realEstate.validation.withLetterOfAttorneyOwner")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-12">
                                            <label>{{$t("realEstate.field.approachMethods")}} <span class="red">*</span></label>
                                        </div>
                                        <div class="col-12">
                                            <div :class="{invalid : $v.realEstate.approach.$error}">
                                                <div class="form-check pl-0 checkbox-inline">
                                                    <label class="form-check-label"
                                                           style="padding-left:22px !important">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="realEstate.approachCost"
                                                               @change="onChangeApproach('Cost',$event)"
                                                        >
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.expense")}}
                                                    </label>
                                                </div>
                                                <div class="form-check checkbox-inline">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="realEstate.approachIncome"
                                                               @change="onChangeApproach('Income',$event)"
                                                        >
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.income")}}
                                                    </label>
                                                </div>
                                                <div class="form-check checkbox-inline">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="realEstate.approachComparative"
                                                               @change="onChangeApproach('Comparative',$event)"
                                                        >
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.comparative")}}
                                                    </label>
                                                </div>
                                                <div class="form-check checkbox-inline">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="checkbox"
                                                        v-model="realEstate.approachRegression"
                                                        @change="onChangeApproach('Regression',$event)"
                                                        >
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.regression")}}
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="red" v-if="$v.realEstate.approach.$error">
                                                {{$t("realEstate.validation.approachMethods")}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationPurpose")}} <span
                                            class="red">*</span></label>
                                    <select class="form-control" v-model="realEstate.evlGoalType"
                                            :class="{invalid : $v.realEstate.evlGoalType.$error}">
                                        <option :value="option.key" v-for="option in goalTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.realEstate.evlGoalType.$error">
                                        {{$t("realEstate.validation.evaluationPurpose")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.name")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="realEstate.name"
                                           :class="{invalid : $v.realEstate.name.$error}"/>
                                    <div class="red" v-if="$v.realEstate.name.$error">
                                        {{$t("realEstate.validation.name")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.cadastreNumber")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="realEstate.cadastreDocNumber"
                                           @keypress.enter="initCadastreApiData"
                                           :class="{invalid : $v.realEstate.cadastreDocNumber.$error}"/>
                                    <div class="red" v-if="$v.realEstate.cadastreDocNumber.$error">
                                        {{$t("realEstate.validation.cadastreNumber")}}
                                    </div>
                                </div>
                                <div class="form-group" v-if="realEstate.approachRegression || realEstate.approachComparative">
                                    <label>{{$t("realEstate.field.buildingCategory")}} <span class="red">*</span></label>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <treeselect class="form-control"
                                                        v-model="realEstate.sectionId"
                                                        placeholder="Танланг..."
                                                        :multiple="false"
                                                        :disable-branch-nodes="true"
                                                        :options="buildingSections"/>
                                        </div>
                                    </div>
                                </div>
                                <div :class="{invalid : $v.realEstate.sections.$error}">
                                    <div class="form-group" v-if="realEstate.approachCost">
                                        <label>{{$t("realEstate.field.cadastreSection")}} <span class="red">*</span></label>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <treeselect class="form-control" v-model="realEstate.cadastreSections"
                                                            placeholder="Танланг..."
                                                            :options="cadastreSections"
                                                            :multiple="true"
                                                            >
                                                    <!--:load-options="onCadastreSectionSearch"-->
                                                    <!--:auto-load-root-options="false"-->
                                                </treeselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="red" v-if="$v.realEstate.sections.$error">
                                    {{$t("realEstate.validation.cadastreSection")}}
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="realEstate.province.id"
                                            @change="onProvinceChange"
                                            :class="{invalid : $v.realEstate.province.$error}">
                                        <option value=""></option>
                                        <option :value="option.id" v-for="option in provinces" :key="option.id">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.realEstate.province.$error">
                                        {{$t("realEstate.validation.province")}}
                                    </div>
                                </div>
                                <div class="form-group" v-if="regions && regions.length > 0">
                                    <label>{{$t("realEstate.field.region")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="realEstate.region.id"
                                            @change="onRegionChange"
                                            :class="{invalid : $v.realEstate.region.$error}">
                                        <option value=""></option>
                                        <option :value="option.id" v-for="option in regions" :key="option.id">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.realEstate.region.$error">
                                        {{$t("realEstate.validation.region")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.addressAddEdit")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="realEstate.address"
                                           :class="{invalid : $v.realEstate.address.$error}"/>
                                    <div class="red" v-if="$v.realEstate.address.$error">
                                        {{$t("realEstate.validation.addressAddEdit")}}
                                    </div>
                                </div>
                                <template v-if="isOrgTypeMib">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibDebtorName")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="realEstate.mibDebtorName"
                                               :class="{invalid : $v.realEstate.mibDebtorName.$error}"/>
                                        <div class="red" v-if="$v.realEstate.mibDebtorName.$error">
                                            {{$t("realEstate.validation.mibDebtorName")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterNumber")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="realEstate.mibLetterNumber"
                                               :class="{invalid : $v.realEstate.mibLetterNumber.$error}"/>
                                        <div class="red" v-if="$v.realEstate.mibLetterNumber.$error">
                                            {{$t("realEstate.validation.mibLetterNumber")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterDate")}} <span
                                                class="red">*</span></label>
                                        <datepicker class="form-control" format="dd/MM/yyyy" v-model="mibLetterDate"
                                                    :clear-button="true"
                                                    :class="{invalid : $v.mibLetterDate.$error}"></datepicker>
                                        <div class="red" v-if="$v.mibLetterDate.$error">
                                            {{$t("realEstate.validation.mibLetterDate")}}
                                        </div>
                                    </div>
                                </template>
                                <div class="border border-gray">
                                    <div class="form-group">
                                        <label class="ml-2">{{$t("realEstate.field.letterNumberText")}}
                                            <span class="text-dark">{{realEstate.contractNumber}}</span>
                                        </label>
                                    </div>
                                    <div class="form-group">
                                        <label class="ml-2">{{$t("realEstate.field.invoiceNumberText")}}
                                            <span class="text-dark">{{realEstate.contractNumberText}}</span>
                                        </label>
                                    </div>
                                    <div class="form-group">
                                        <label class="ml-2">{{$t("realEstate.field.reportNumberText")}}
                                            <span v-if="showReportButton" class="text-dark">{{realEstate.reportNumberText}}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.areaTotal")}} <span class="red">*</span></label>
                                    <numeric-input v-model="realEstate.evlGroundArea" :precision="2"
                                                   :class="{invalid : $v.realEstate.evlGroundArea.$error}"></numeric-input>
                                    <div class="red" v-if="$v.realEstate.evlGroundArea.$error">
                                        {{$t("realEstate.validation.areaTotal")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.areaUnderConstruction")}} <span
                                            class="red">*</span></label>
                                    <numeric-input v-model="realEstate.evlBuildingWidthArea" :precision="2"
                                                   :class="{invalid : $v.realEstate.evlBuildingWidthArea.$error}"></numeric-input>
                                    <div class="red" v-if="$v.realEstate.evlBuildingWidthArea.$error">
                                        {{$t("realEstate.validation.areaUnderConstruction")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.areaUseful")}} <span class="red">*</span></label>
                                    <numeric-input v-model="realEstate.evlUsefulField" :precision="2"
                                                   :class="{invalid : $v.realEstate.evlUsefulField.$error}"

                                    ></numeric-input>
                                    <div class="red" v-if="$v.realEstate.evlUsefulField.$error">
                                        {{$t("realEstate.validation.areaUseful")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-12">
                                            <label>{{$t("realEstate.field.valueType")}} <span
                                                    class="red">*</span></label>
                                        </div>
                                        <div class="col-12" :class="{invalid : $v.realEstate.evlValueType.$error}">
                                            <div class="form-check form-check-radio checkbox-inline pl-0"
                                                 style="margin-left:-0.8rem">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="evlValueType"
                                                           value="Market" v-model="realEstate.evlValueType">
                                                    <span class="form-check-sign"></span>
                                                    {{$t("realEstate.valueType.market")}}
                                                </label>
                                            </div>
                                            <div class="form-check form-check-radio checkbox-inline">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="evlValueType"
                                                           value="NonMarket" v-model="realEstate.evlValueType">
                                                    <span class="form-check-sign"></span>
                                                    {{$t("realEstate.valueType.nonMarket")}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="red" v-if="$v.realEstate.evlValueType.$error">
                                        {{$t("realEstate.validation.valueType")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.propertyType")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="realEstate.evlPropertyType"
                                            :class="{invalid : $v.realEstate.evlPropertyType.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in propertyTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.realEstate.evlPropertyType.$error">
                                        {{$t("realEstate.validation.propertyType")}}
                                    </div>
                                </div>
                                <div class="form-group" v-if="hasPermission('REAL_ESTATE_ASSIGN')">
                                    <label>{{$t("realEstate.field.evaluator")}}</label>
                                    <select class="form-control" v-model="realEstate.employee.id"
                                            :class="{invalid: $v.realEstate.employee.$error}">
                                        <option value=""></option>
                                        <option :value="option.id" v-for="option in employees" :key="option.id">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.realEstate.employee.$error">
                                        {{$t("realEstate.validation.evaluator")}}
                                    </div>
                                </div>
                                <template>
                                    <div class="form-group">
                                        <div class="form-check checkbox-inline">
                                            <label class="form-check-label pl-0">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="realEstate.lightConstructiveElement"
                                                       :disabled="!hasPermission('REAL_ESTATE_LIGHT_CONSTRUCTIVE_ELEMENT')"
                                                       name="contractAmountByAgreement">
                                                <span class="form-check-sign"></span>
                                                Енгил конструктив элемент
                                            </label>
                                        </div>
                                    </div>
                                </template>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.contractAmount")}}</label>
                                    <numeric-input class="form-control" v-model="realEstate.evlContractAmount"
                                                   :disabled="(isOwnerTypeLegal && isOrgTypeMib) || isPaid"
                                                   :class="{invalid: $v.realEstate.evlContractAmount.$error}"
                                                   :controls="false" :precision="2"></numeric-input>

                                    <div v-if="isOwnerTypeLegal && !isOrgTypeMib">
                                        <label>Олдиндан тўлов фоизи 0% дан 100% гача!</label>
                                        <numeric-input class="form-control" v-model="realEstate.prepayment"
                                                       :controls="false" :precision="2"></numeric-input>
                                    </div>
                                    <span>ҚҚС билан: {{realEstate.evlAmountToPay | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                    <div class="form-group"><span>Туланган сумма: {{realEstate.paidAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span></div>
                                    <div class="red" v-if="$v.realEstate.evlContractAmount.$error">
                                        {{$t("realEstate.validation.evlContractAmount")}}
                                    </div>
                                </div>
                                <!--<template v-if="hasPermission('REAL_ESTATE_CONTRACT_AMOUNT_BY_AGREEMENT')">-->
                                    <!--<div class="col col-12" style="border: 1px solid #000">-->
                                        <!--<div class="form-group">-->
                                            <!--<div class="form-check checkbox-inline">-->
                                                <!--<label class="form-check-label pl-0">-->
                                                    <!--<input class="form-check-input" type="checkbox"-->
                                                           <!--v-model="realEstate.contractAmountByAgreement"-->
                                                           <!--name="contractAmountByAgreement">-->
                                                    <!--<span class="form-check-sign"></span>-->
                                                    <!--Келишув бўйича-->
                                                <!--</label>-->
                                            <!--</div>-->
                                        <!--</div>-->
                                        <!--<div class="form-group">-->
                                            <!--<label>Келишув бўйича изох <span v-if="realEstate.contractAmountByAgreement"-->
                                                                             <!--class="red">*</span></label>-->
                                            <!--<textarea type="text" class="form-control"-->
                                                      <!--v-model="realEstate.contractAmountByAgreementDescription"></textarea>-->
                                        <!--</div>-->
                                        <!--<button class="all-btn add-btn ml-3" :disabled="processing" @click="saveContractAmountByAgreement">-->
                                            <!--Саклаш-->
                                        <!--</button>-->
                                    <!--</div>-->
                                <!--</template>-->
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluatorIdea")}}</label>
                                    <textarea type="text" class="form-control"
                                              v-model="realEstate.evaluatorIdea"></textarea>
                                </div>
                                <template v-if="!realEstate.approachRegression">
                                    <div class="form-group">
                                        <!--<label>{{$t("realEstate.field.landComparison")}}</label>-->
                                        <div class="form-check checkbox-inline">
                                            <label class="form-check-label pl-0">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="realEstate.landComparisonEnabled"
                                                       name="landComparisonEnabled"
                                                       @change="handleChangeLand($event)"
                                                >
                                                <span class="form-check-sign"></span>
                                                {{$t("realEstate.field.landComparison")}}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <!--<label>{{$t("realEstate.field.landComparison")}}</label>-->
                                        <div class="form-check checkbox-inline">
                                            <label class="form-check-label pl-0">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="realEstate.landCapitalizationEnabled"
                                                       name="landCapitalizationEnabled"
                                                       @change="handleChangeLand($event)"
                                                >
                                                <span class="form-check-sign"></span>
                                                {{$t("realEstate.field.landCapitalization")}}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="realEstate.landCapitalizationEnabled">
                                        <div class="section-header">
                                            <label>{{$t("realEstate.field.landCapitalizationTitle")}}</label>
                                        </div>
                                        <div class="table-responsive">
                                            <div class="table-wrapper">
                                              <table class="table table-bordered">
                                                  <thead>
                                                    <tr>
                                                      <th width="20%" class="text-center"><label>Ставка</label></th>
                                                      <th width="20%" class="text-center"><label>Гектар</label></th>
                                                      <th width="20%" class="text-center"><label>1 гектар сўммаси</label></th>
                                                      <th width="5%" class="text-center"><label>Молиялаш ставкаси(%)</label></th>
                                                      <th width="100%" class="text-center"><label>Баҳоси(сўм)</label></th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                  <tr>
                                                      <td class="text-right">{{calculated.taxPerHectare}}</td>
                                                      <td class="text-right">{{calculated.areaInHectare | currency('', 3, {
                                                          thousandsSeparator: ' ' })}}
                                                      </td>
                                                      <td class="text-right">{{calculated.landTaxAmount | currency('', 2, {
                                                          thousandsSeparator: ' ' })}}
                                                      </td>
                                                      <td class="text-center">{{calculated.financingRate | currency('', 2, {
                                                          thousandsSeparator: ' ' })}}
                                                      </td>
                                                      <td class="text-right">{{calculated.calculatedTotalLandPrice |
                                                          currency('', 2, { thousandsSeparator: ' ' })}}
                                                      </td>
                                                  </tr>
                                                  </tbody>
                                              </table>
                                            </div>
                                        </div>
                                    </div>
                              </template>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.locationText")}}</label>
                                    <real-estate-location-map :dataSource="realEstate.target" :marker="false" :height="320"/>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4>{{$t("realEstate.field.docsToSubmit")}}</h4>
                                </div>
                            </div>
                            <template v-if="realEstate.evlGoalType">

                                <template v-if="isOwnerTypePhysical">
                                    <RealEstateDropZone code="passportDropZone" label="realEstate.field.docPassport"
                                                        folder="Passport" :data="realEstate.passport"
                                                        v-if="isGoalTypeCommon"
                                                        @change="(files) => {realEstate.passport = files}"
                                                        :has-error="$v.realEstate.passport.$error"/>
                                    <RealEstateDropZone code="applicationDropZone"
                                                        label="realEstate.field.docApplication"
                                                        folder="ApplicationForm" :data="realEstate.applicationForm"
                                                        v-if="isGoalTypeCommon"
                                                        @change="(files) => {realEstate.applicationForm = files}"
                                    />
                                    <!--:has-error="$v.realEstate.applicationForm.$error"-->
                                </template>

                                <RealEstateDropZone code="documentsDropZone" label="realEstate.field.docDocuments"
                                                    folder="Documents" :data="realEstate.documents"
                                                    v-if="isOwnerTypeLegal && (isGoalTypeCommon || isPrivatizationZero)"
                                                    @change="(files) => {realEstate.documents = files}"
                                                    :has-error="$v.realEstate.documents.$error"/>

                                <RealEstateDropZone code="cadastreDropZone" label="realEstate.field.docCadastre"
                                                    folder="Cadastre" :data="realEstate.cadastre"
                                                    v-if="isOwnerTypeLegal || isOwnerTypePhysical"
                                                    @change="(files) => {realEstate.cadastre = files}"
                                                    :has-error="$v.realEstate.cadastre.$error"/>

                                <!--Хусусийлаштириш максадида-->
                                <template v-if="isOwnerTypeLegal && isPrivatizationSimple">
                                    <RealEstateDropZone code="privatizationLetterDropZone"
                                                        label="realEstate.field.docPrivatizationLetter"
                                                        folder="PrivatizationLetter"
                                                        :data="realEstate.privatizationLetter"
                                                        @change="(files) => {realEstate.privatizationLetter = files}"
                                                        :has-error="$v.realEstate.privatizationLetter.$error"/>
                                    <RealEstateDropZone code="privatizationCommissionOrderDropZone"
                                                        label="realEstate.field.docPrivatizationCommissionOrder"
                                                        folder="PrivatizationCommissionOrder"
                                                        :data="realEstate.privatizationCommissionOrder"
                                                        @change="(files) => {realEstate.privatizationCommissionOrder = files}"
                                                        :has-error="$v.realEstate.privatizationCommissionOrder.$error"/>
                                    <RealEstateDropZone code="ownershipCertificateDropZone"
                                                        label="realEstate.field.docOwnershipCertificate"
                                                        folder="OwnershipCertificate"
                                                        :data="realEstate.ownershipCertificate"
                                                        @change="(files) => {realEstate.ownershipCertificate = files}"
                                                        :has-error="$v.realEstate.ownershipCertificate.$error"/>
                                </template>

                                <!--Мажбурий ижро бюроси-->
                                <template>
                                    <RealEstateDropZone code="actOfSaleDropZone" label="realEstate.field.docActOfSale"
                                                        folder="ActOfSale" :data="realEstate.actOfSale"
                                                        @change="(files) => {realEstate.actOfSale = files}"
                                                        :has-error="$v.realEstate.actOfSale.$error"/>
                                    <RealEstateDropZone code="decisionDropZone" label="realEstate.field.docDecision"
                                                        folder="Decision" :data="realEstate.decision"
                                                        @change="(files) => {realEstate.decision = files}"
                                                        :has-error="$v.realEstate.decision.$error"/>
                                    <RealEstateDropZone code="playlistDropZone" label="realEstate.field.docPlaylist"
                                                        folder="ExecutivePlaylist" :data="realEstate.playlist"
                                                        @change="(files) => {realEstate.playlist = files}"
                                                        :has-error="$v.realEstate.playlist.$error"/>
                                    <RealEstateDropZone code="balanceDropZone" label="realEstate.field.docBalance"
                                                        folder="Balance" :data="realEstate.balance"
                                                        @change="(files) => {realEstate.balance = files}"
                                    />
                                    <!-- :has-error="$v.realEstate.balance.$error"-->
                                </template>
                            </template>
                        </div>
                        <div class="row" v-if="realEstate.id && realEstate.id > 0">
                              <template>
                                  <PreviewDropZone code="checkPaymentDropZone" :label="checkPaymentLbl"
                                                   :data="realEstate.checkPaymentFiles"
                                                   @change="(files) => {realEstate.checkPaymentFiles = files}"
                                  />
                                  <!-- :has-error="$v.realEstate.balance.$error"-->
                              </template>
                              <div class="form-check checkbox-inline">
                                  <label class="form-check-label pl-3 font-weight-bold">
                                      <input class="form-check-input" type="checkbox"
                                             v-model="realEstate.displayReport"
                                             @change="showReport()"
                                             v-bind:disabled="!hasPermission('REAL_ESTATE_DISPLAY_REPORT')"
                                      >
                                      <span class="form-check-sign"></span>
                                      {{$t("report.field.showReport")}}
                                  </label>
                              </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-12 mt-2">
                                <div class="form-group">
                                    <real-estate-status-view :realEstate="realEstate"/>
                                </div>
                            </div>
                            <div class="col-md-6 col-12 mt-2">
                                <div class="form-group">
                                    <real-estate-history-view/>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="showReportButton">
                            <div class="col-12 btns-box">
                                <button
                                        class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('REAL_ESTATE_REPORT_WORD')"
                                        @click="reportDocQrCode(realEstate)">
                                    <i v-if="isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWordQrCode")}}
                                </button>
                                <button
                                        class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('REAL_ESTATE_REPORT_WORD')"
                                        @click="reportDoc(realEstate)">
                                    <i v-if="isDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWord")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('REAL_ESTATE_REPORT_PDF_QR_CODE')"
                                        @click="reportPdfQrCode(realEstate)">
                                    <i v-if="isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('REAL_ESTATE_REPORT_PDF')"
                                        @click="reportPdf(realEstate)">
                                    <i v-if="isPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.title")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('REAL_ESTATE_CONTRACT_PDF_QR_CODE')"
                                        @click="reportContractQrCodePdf(realEstate)">
                                    <i v-if="isCPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdfQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('REAL_ESTATE_CONTRACT_PDF')"
                                        @click="reportContractPdf(realEstate)">
                                    <i v-if="isCPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdf")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('REAL_ESTATE_CONTRACT_WORD')"
                                        @click="reportContractDocQrCode(realEstate)">
                                    <i v-if="isCDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWordQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('REAL_ESTATE_CONTRACT_WORD')"
                                        @click="reportContractDoc(realEstate)">
                                    <i v-if="isCDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWord")}}
                                </button>
                            </div>
                        </div>
                        <div class="row" v-if="realEstate.id && realEstate.id > 0">
                            <div class="col-12">
                                <div class="section-header">

                                    <h4 class="pull-left">
                                        {{$t("realEstate.field.buildingsToEvaluate")}}
                                    </h4>

                                     <button class="all-btn add-btn pull-right" @click="addBuilding" v-if="isEditable">
                                        {{$t("realEstate.field.addBuilding")}}
                                    </button>
                                </div>
                                <div class="table-responsive">
                                    <div class="table-wrapper">
                                      <table class="table table-hover">
                                          <thead>
                                          <tr>
                                              <th width="5%">№</th>
                                              <th width="10%">Бино номи</th>
                                              <th width="10%" class="text-center">Бино хажми (м3)</th>
                                              <th width="15%" class="text-center">Қурилиш ости майдони (м2)</th>
                                              <th width="15%" class="text-right">Бахоланган қиймати</th>
                                              <th width="15%" class="text-right">Қайси бинога бириктирилган</th>
                                              <th width="100%" class="text-center">ЖАРАЁН</th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          <tr v-for="(building, index) in realEstate.buildings" :key="building.id">
                                              <td>{{index+1}}</td>
                                              <td>{{building.name}}</td>
                                              <!--<td class="text-center">-->
                                              <!--<span v-if="building.madeYear">{{building.madeYear}} й</span>-->
                                              <!--</td>-->
                                              <td class="text-center">{{building.volume}} м3</td>
                                              <td class="text-center">{{building.area}} м2</td>
                                              <td class="text-right">
                                                      <!--<span v-if="building.calculated && building.calculated.price && building.calculated.price.expense">-->
                                                          <!--{{building.calculated.price.expense | currency('', 2, { thousandsSeparator: ' ' })}} сум-->
                                                      <!--</span>-->
                                                  <span>{{calculateApproachTotal(building) | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                                              </td>
                                              <td class="text-center">
                                                  {{building.parent && building.parent.name ? building.parent.name : ''}}
                                              </td>
                                              <td class="td-actions text-center flex-row justify-content-center">
                                                  <template v-if="realEstate.approachRegression">
                                                      <router-link tag="button"
                                                                   :to="'/real-estate/building/regression/' + building.realEstateId + '/' + building.id"
                                                                   v-tooltip="'Регрессион модел'"
                                                                   class="all-btn edit-btn table-action">
                                                          <i class="fa fa-balance-scale"></i>
                                                      </router-link>
                                                  </template>
                                                  <template v-else-if="hasPermission('REAL_ESTATE_BUILDING_EDIT')">
                                                      <router-link tag="button"
                                                                   :to="'/real-estate/building/comparison/' + building.realEstateId + '/' + building.id"
                                                                   v-tooltip="'Қиёсий ёндашув'"
                                                                   class="all-btn edit-btn table-action"
                                                                   v-if="realEstate.approachComparative">
                                                          <i class="fa fa-balance-scale"></i>
                                                      </router-link>
                                                      <router-link tag="button"
                                                                   :to="'/real-estate/building/comparison-income/' + building.realEstateId + '/' + building.id"
                                                                   v-tooltip="'Даромад ёндашув'"
                                                                   class="all-btn add-btn table-action"
                                                                   v-if="realEstate.approachIncome">
                                                          <i class="fa fa-file-o"></i>
                                                      </router-link>
                                                      <router-link tag="button"
                                                                   :to="'/real-estate/building/edit/' + building.realEstateId + '/' + building.id"
                                                                   v-tooltip="'Бинони ўзгартириш'"
                                                                   class="all-btn edit-btn table-action">
                                                          <i class="fa fa-edit"></i>
                                                      </router-link>
                                                      <button type="button" v-tooltip="'Бинони ўчириш'"
                                                              v-if="isEditable"
                                                              class="all-btn delete-btn table-action"
                                                              @click="showDeleteBuildingDialog(building, index)">
                                                          <i class="fa fa-times"></i>
                                                      </button>
                                                  </template>
                                              </td>
                                          </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                </div>
                            </div>
                        </div>

<!--                        <div class="row" v-if="realEstate.id && realEstate.id > 0">-->
<!--                            <div class="col-12">-->
<!--                                <div class="section-header">-->
<!--                                    <h4 class="pull-left">-->
<!--                                        {{$t("payment.list")}}-->
<!--                                    </h4>-->
<!--                                    <button class="all-btn add-btn pull-right" @click="addBuilding">-->
<!--                                        {{$t("payment.add")}}-->
<!--                                    </button>-->
<!--                                </div>-->
<!--                                <div class="table-responsive">-->
<!--                                    <table class="table table-hover">-->
<!--                                        <thead>-->
<!--                                        <tr>-->
<!--                                            <th width="20%" class="text-right">Тўланган сумма</th>-->
<!--                                            <th width="20%" class="text-center">Тўланган жойи</th>-->
<!--                                            <th width="25%">Изоҳ</th>-->
<!--                                            <th width="20%">Тўловчи</th>-->
<!--                                            <th width="100%" class="text-center">ЖАРАЁН</th>-->
<!--                                        </tr>-->
<!--                                        </thead>-->
<!--                                        <tbody>-->
<!--                                        <tr v-for="(payment, index) in realEstate.payments" :key="payment.id">-->
<!--                                            <td class="text-right">{{payment.amount | currency('', 2, { thousandsSeparator: ' ' })}}</td>-->
<!--                                            <td class="text-center">{{payment.source}}</td>-->
<!--                                            <td>{{payment.note}}</td>-->
<!--                                            <td class="text-right">{{(payment.payer && payment.payer.name) ? payment.payer.name : ''}}</td>-->

<!--                                            <td class="td-actions text-center">-->
<!--                                                <router-link tag="button"-->
<!--                                                             :to="'/real-estate/payment/edit/' + payment.id"-->
<!--                                                             v-tooltip="'Тўловни ўзгартириш'"-->
<!--                                                             class="all-btn edit-btn table-action">-->
<!--                                                    <i class="fa fa-edit"></i>-->
<!--                                                </router-link>-->
<!--                                                <button type="button" v-tooltip="'Тўловни ўчириш'"-->
<!--                                                        class="all-btn delete-btn table-action"-->
<!--                                                        @click="showDeletePaymentDialog(payment, index)">-->
<!--                                                    <i class="fa fa-times"></i>-->
<!--                                                </button>-->
<!--                                            </td>-->
<!--                                        </tr>-->
<!--                                        </tbody>-->
<!--                                    </table>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing"
                                        v-if="canSave">{{$t("action.save")}}
                                </button>
                                <button class="all-btn" @click="changeStatus('Evaluated')"
                                        :disabled="processing" v-if="canEvaluate">{{$t("realEstate.action.evaluate")}}
                                </button>
                                <button class="all-btn add-btn" @click="changeStatus('Confirmed')"
                                        :disabled="processing" v-if="canConfirm">{{$t("realEstate.action.confirm")}}
                                </button>
                                <button class="all-btn add-btn" @click="sendReportToMIBRealEstate()"
                                        v-if="hasPermission('SEND_TO_MIB_REAL_ESTATE') && isOrgTypeMib && realEstate.status === 'Confirmed'"
                                >
                                    {{$t("realEstate.action.sendReportToMIB")}}
                                </button>

                                <button class="all-btn edit-btn" @click="changeStatus('NotFullyEvaluated')"
                                        :disabled="processing" v-if="canReEvaluate">
                                    {{$t("realEstate.action.reevaluate")}}
                                </button>

                                <button class="btn btn-warning ml-3" @click="getGenericEncryptUrl(realEstate)"
                                        :disabled="processing" v-if="hasPermission('REAL_ESTATE_CONFIRM') && realEstate.status === 'Confirmed' && realEstate.hasEsp">
                                    ЭЦП имзолаш Test
                                </button>

                                <router-link
                                        tag="button"
                                        v-tooltip="'ЭЦПни тасдиқлаш'"
                                        :to="'/real-estate/esp/' + realEstate.id"
                                        class="all-btn pull-right"
                                        v-if="hasPermission('REAL_ESTATE_CONFIRM') && realEstate.status === 'Confirmed' && realEstate.hasEsp"
                                >
                                    {{$t("realEstate.action.espSign")}}
                                </router-link>
                                <!--<router-link-->
                                    <!--tag="button"-->
                                    <!--v-tooltip="'Баҳоловчи ЭЦПни тасдиқлаш'"-->
                                    <!--:to = "`/real-estate/appraiser-report/esp/${realEstate.id}`"-->
                                    <!--class="all-btn add-btn pull-right"-->
                                    <!--v-if="hasPermission('REAL_ESTATE_EVALUATE') && realEstate.status === 'Confirmed'"-->
                                <!--&gt;-->
                                    <!--{{$t("realEstate.action.appraiserEspSign")}}-->
                                <!--</router-link>-->
                            </div>
                        </div>
                        <!--<div class="row" v-if="realEstate.status === 'Confirmed'">-->
                            <!--<div class="col">-->
                                <!--<div class="alert alert-warning d-flex">-->
                                    <!--<i class="fa-fw fa fa-warning mr-1"></i>-->
                                    <!--<label style="color: #E74C3C; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong> Баҳоловчи ҳисоботни ЭЦП орқали тасдиқламаган. ЭЦП имзолаш тугмасини босинг!</label>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="row mt-3" v-if="realEstate.status === 'Confirmed'">
                            <div class="col">
                                <div class="alert alert-warning d-flex">
                                    <i class="fa-fw fa fa-warning mr-1"></i>
                                    <label style="color: #4d2600; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong> Тасдиқлагандан (қайта Тасдиқлагандан сўнг хам) ЭЦПни имзоланг. ЭЦП имзолаш тугмасини босинг!</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import Treeselect from '@riophae/vue-treeselect';
    import {numericTypes} from '@/shared/constants/mask'
    import {EVL_GOAL_TYPES, EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import RealEstateDropZone from '@/views/real-estate/RealEstateDropZone'
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate} from '@/shared/utils';
    import {required, requiredUnless, minValue, minLength} from 'vuelidate/lib/validators';
    import RealEstateLocationMap from '@/views/e-appraisal/RealEstateLocationMap'
    import RealEstateStatusView from './RealEstateStatusView.vue'
    import RealEstateHistoryView from './RealEstateHistoryView.vue'

    export default {
        name: "RealEstateEdit",
        components: {
            Datepicker,
            Treeselect,
            RealEstateDropZone,
            PreviewDropZone,
            RealEstateLocationMap,
            RealEstateStatusView,
            RealEstateHistoryView
        },
        data() {
            return {
                processing: false,
                isDocQrLoading: false,
                isDocLoading: false,
                isPdfLoading: false,
                isPdfQrLoading: false,
                isCDocLoading: false,
                isCPdfLoading: false,
                isCDocQrLoading: false,
                isCPdfQrLoading: false,
                numericTypes: numericTypes,
                ownerFilter: initFilterModel(),
                customerFilter: initFilterModel(),
                cadastreSectionFilter: initFilterModel(),
                show: false,
                realEstate: {
                    id: null,
                    owner: null,
                    customer: null,
                    hasCustomer: false,
                    approachCost: false,
                    approachIncome: false,
                    approachComparative: false,
                    category: 'Notorious',
                    evlGoalType: 'Predge',
                    name: '',
                    cadastreDocNumber: '',
                    cadastreSections: [],

                    address: '',
                    province: {},
                    region: {},

                    //MIB
                    mibDebtorName: '',
                    mibLetterNumber: '',
                    mibLetterDate: null,
                    mibRegion: null,

                    evlGroundArea: 0,
                    evlBuildingWidthArea: 0,
                    evlUsefulField: 0,
                    evlContractAmount: 0,
                    prepayment: 0,

                    employee: {},

                    evlValueType: 'Market',
                    evlPropertyType: '',

                    landComparisonEnabled: false,
                    landCapitalizationEnabled: false,

                    buildings: [],
                    payments: [],

                    passport: [],// паспорт файл
                    actOfSale: [],// далолатнома
                    decision: [],// карор нусхаси
                    playlist: [],// ижро варакаси
                    balance: [],// баланс
                    cadastre: [],// кадастр хужжати
                    applicationForm: [],// ариза
                    documents: [],// мурожат хати
                    buildingPhotos: [],// бино расмлари
                    privatizationLetter: [],// Кумитанинг бахолаш тугрисида хати
                    privatizationCommissionOrder: [],// Хусусийлаштириш комиссиясининг буйрук ва протоллари
                    ownershipCertificate: [],// Эгалик хукукинитасдикловчи гувохнома
                    checkPaymentFiles: [],// to'lov haqidagi hujjatlar
                    status: 'Pending',

                    displayReport: false,
                    evaluatorIdea: '',

                    landCapitalization: {
                        financingRate: 0,
                        taxPerHectare: 0,
                        calculatedTotalPrice: 0
                    },
                    reasonDesc: '',
                    approachRegression: false,
                    sectionId: null,
                    contractAmountByAgreement: null,
                    contractAmountByAgreementDescription: null,
                    lightConstructiveElement: false,
                    financingRate: 0,
                    evaluationRespectiveType: "OTHER"
                },
                owners: [],
                customers: [],
                provinces: [],
                regions: [],
                cadastreSections: [],
                employees: [],
                goalTypes: EVL_GOAL_TYPES,
                goalTypesCommon: ['Predge', 'Sale', 'DeterminingValue', 'FormationStatutoryFund', 'Losses','DeterminationMarketValue','Investment','AcceptToBalance','DeterminationValue'],
                propertyTypes: EVL_PROPERTY_TYPES,
                mibLetterDate: null,
                financingRate: 0,
                taxPerHectare: 0,
                buildingSections: [],
                evaluationRespectiveTypes: []
            }
        },
        validations() {
            return {
                realEstate: {
                    /*LEFT PANEL*/
                    owner: {
                        required: required
                    },
                    customer: {
                        required: requiredUnless(() => {
                            return !(this.realEstate.hasCustomer);
                        })
                    },
                    approach: {
                        required: requiredUnless(() => {
                            return !(!(this.realEstate.approachCost || this.realEstate.approachComparative || this.realEstate.approachIncome || this.realEstate.approachRegression));
                        })
                    },
                    evlGoalType: {
                        required: required
                    },
                    name: {
                        required: required
                    },
                    cadastreDocNumber: {
                        required: required
                    },
                    sections: {
                        required: requiredUnless( () => {
                            return !(this.isSections);
                        })
                    },
                    // cadastreSections: {
                    //     required: required,
                    //     minLength: minLength(1)
                    // },
                    province: {
                        id: {
                            required: required
                        }
                    },
                    region: {
                        id: {
                            required: required
                        }
                    },
                    address: {
                        required: required
                    },
                    /*RIGHT PANEL*/
                    evlGroundArea: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlBuildingWidthArea: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlUsefulField: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlValueType: {
                        required: required
                    },
                    evlPropertyType: {
                        required: required
                    },
                    employee: {
                        id: {
                            required: required
                        }
                    },
                    // MIB
                    mibDebtorName: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    },
                    mibLetterNumber: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    },
                    /*FILE UPLOADS*/
                    passport: {
                        required: requiredUnless(() => {
                            return !(this.isOwnerTypePhysical);
                        }),
                        minLength: minLength(1)
                    },
                    // applicationForm: {
                    //     required: requiredUnless(() => {
                    //         return !(this.isOwnerTypePhysical);
                    //     }),
                    //     minLength: minLength(1)
                    // },
                    documents: {
                        required: requiredUnless(() => {
                            return !(this.isOwnerTypeLegal && (this.isGoalTypeCommon || this.isPrivatizationZero)) || this.isOrgTypeMib;
                        }),
                        minLength: minLength(1)
                    },
                    cadastre: {
                        required: requiredUnless(() => {
                            return !(this.isOwnerTypeLegal || (this.isOwnerTypePhysical && this.isGoalTypeCommon));
                        }),
                        minLength: minLength(1)
                    },
                    privatizationLetter: {
                        required: requiredUnless(() => {
                            return !(this.isOwnerTypeLegal && this.isPrivatizationSimple);
                        }),
                        minLength: minLength(1)
                    },
                    privatizationCommissionOrder: {
                        required: requiredUnless(() => {
                            return !(this.isOwnerTypeLegal && this.isPrivatizationSimple);
                        }),
                        minLength: minLength(1)
                    },
                    ownershipCertificate: {
                        required: requiredUnless(() => {
                            return !(this.isOwnerTypeLegal && this.isPrivatizationSimple);
                        }),
                        minLength: minLength(1)
                    },
                    actOfSale: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    decision: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    playlist: {
                        required: requiredUnless(() => {
                            return true;
                        }),
                        minLength: minLength(1)
                    },
                    evlContractAmount: {
                        required: requiredUnless(() => {
                            return  (this.isOwnerTypeLegal && this.isOrgTypeMib)
                        }),
                        minValue: minValue(!(this.isOwnerTypeLegal && this.isOrgTypeMib) ? 0.01 : 0)
                    },
                    // balance: {
                    //     required: requiredUnless(() => {
                    //         return !(this.isOrgTypeMib);
                    //     }),
                    //     minLength: minLength(1)
                    // }
                    evaluationRespectiveType: {
                        required: required
                    }
                },
                mibLetterDate: {
                    required: requiredUnless(() => {
                        return !(this.isOrgTypeMib);
                    })
                }
            };
        },
        computed: {
            isOwnerTypePhysical() {
                return !!(this.realEstate.owner && this.realEstate.owner.type && this.realEstate.owner.type === 'Physical');
            },
            isOwnerTypeLegal() {
                return !!(this.realEstate.owner && this.realEstate.owner.type && this.realEstate.owner.type === 'Legal');
            },
            isOrgTypeMib() {
                return !!(this.realEstate.owner && this.realEstate.owner.organizationType && this.realEstate.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');
            },
            isGoalTypeCommon() {
                return this.isGoalType(this.goalTypesCommon);
            },
            isPrivatizationSimple() {
                return this.isGoalType(['Privatization']);
            },
            isPrivatizationZero() {
                return this.isGoalType(['PrivatizationZero']);
            },
            canSave() {
                return (this.realEstate.status === 'Pending' || this.realEstate.status === 'AssignedToEvaluator' || this.realEstate.status === 'NotFullyEvaluated');
            },
            canEvaluate() {
                let hasBuildingCalculated = false;
                if (this.realEstate.status === 'NotFullyEvaluated' && this.hasPermission('REAL_ESTATE_EVALUATE')) {
                    this.realEstate.buildings.forEach((building) => {
                        if ((building.calculated && building.calculated.price && building.calculated.price.expense && building.calculated.price.expense > 0) ||
                            (building.comparison && building.comparison.calculatedTotalPrice && building.comparison.calculatedTotalPrice > 0) ||
                            (building.comparisonIncome && building.comparisonIncome.calculated &&  building.comparisonIncome.calculated.total && building.comparisonIncome.calculated.total > 0) ||
                            (building.comparisonRegression && building.comparisonRegression.totalPrice && building.comparisonRegression.totalPrice > 0))
                        {
                            hasBuildingCalculated = true;
                        }
                    });
                }
                return hasBuildingCalculated;
            },
            canConfirm() {
                return this.realEstate.status === 'Evaluated' && this.hasPermission('REAL_ESTATE_CONFIRM') && (this.realEstate.appraiserReportEsp || !this.realEstate.hasEsp);
            },
            canReEvaluate() {
                return (this.realEstate.status === 'Evaluated' || this.realEstate.status === 'Confirmed') && this.hasPermission('REAL_ESTATE_REEVALUATE');
            },
            checkPaymentLbl() {
                return this.isOrgTypeMib ? "realEstate.field.checkPaymentFilesMib" : "realEstate.field.checkPaymentFiles";
            },
            calculated() {

                let landTaxAmount = 0;
                let financingRate = 0;
                let taxPerHectare = 0;
                let calculatedTotalLandPrice = 0;

                const areaInHectare = this.realEstate.evlGroundArea * 0.0001;

                if (this.taxPerHectare > 0) {
                    taxPerHectare = this.taxPerHectare;
                    landTaxAmount = taxPerHectare * areaInHectare;
                }
                if (this.financingRate > 0) {
                    financingRate = this.financingRate;
                    calculatedTotalLandPrice = landTaxAmount / financingRate * 100;
                }
                return {
                    financingRate: financingRate,
                    taxPerHectare: taxPerHectare,
                    areaInHectare: areaInHectare,
                    landTaxAmount: landTaxAmount,
                    calculatedTotalLandPrice: calculatedTotalLandPrice
                }
            },
            showReportButton() {
                return (this.realEstate.status === 'Evaluated' || this.realEstate.status === 'Confirmed') && this.realEstate.id && this.realEstate.id > 0;
            },
            isSections() {
                return !(this.realEstate.cadastreSections && this.realEstate.cadastreSections.length > 0) && this.realEstate.approachCost
            },
            isEditable() {
                return this.realEstate.status !== 'Confirmed';
            },
            isPaid() {
                return this.realEstate.paidAmount > 0;
            },
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;
                let category = '';
                if (this.$route && this.$route.meta && this.$route.meta.category && this.$route.meta.category.length > 0) {
                    category = this.$route.meta.category;
                }
                const promises = [
                    this.$http.get('admin/real-estate/init/' + ((category && category.length > 0) ? category : 'na') + '/' + ((id && id > 0) ? id : '0'))
                ];
                if (id && id > 0) {
                    promises.push(this.$http.get('admin/real-estate/' + id));
                } else {
                    vm.realEstate.category = category;
                }
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                    vm.employees = initData.employees;
                    vm.cadastreSections = initData.cadastreSections.map((item) => {
                        item.label = item.name;
                        return item;
                    });
                    vm.buildingSections = initData.buildingSections;
                    if (values.length >= 2) {
                        const editData = values[1].data;
                        if (!editData.evlGoalType) {
                            editData.evlGoalType = '';
                        }
                        if (!editData.province) {
                            editData.province = {};
                        }
                        if (!editData.region) {
                            editData.region = {};
                        }
                        if (!editData.employee) {
                            editData.employee = {};
                        }
                        vm.mibLetterDate = parseDate(editData.mibLetterDate);
                        vm.realEstate = editData;
                        if (editData.landCapitalization && editData.landCapitalization.financingRate > 0 && editData.landCapitalization.taxPerHectare > 0) {
                            vm.initLandCapitalizationData(editData.landCapitalization)
                        }

                        vm.initProvinceRegions();
                        // vm.onGoalTypeChange();
                    }
                });
            },
            initCadastreApiData() {
                console.log("Cadastre api init");
            },
            addBuilding() {
                this.$router.push('/real-estate/building/new/' + this.realEstate.id);
            },
            cancel() {
                this.$router.push('/real-estate/' + this.realEstate.category);
            },
            headerAction(action) {
                if (this.isEditable) {
                    this.saveAndGo(action)
                } else if ('coordination' === action) {
                    this.$router.push('/real-estate/coordination/' + this.realEstate.id + "/" + true);
                } else if ('land' === action) {
                    this.$router.push('/real-estate/land/' + this.realEstate.id);
                }
            },
            save() {
                this.saveAndGo('close');
            },
            saveAndGo(action) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                if (this.realEstate.prepayment && !(this.realEstate.prepayment >= 0 && this.realEstate.prepayment <= 100)) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
                        type: 'warning'
                    });
                    return ;
                }

                this.processing = true;
                if (this.mibLetterDate) {
                    this.realEstate.mibLetterDate = formatDate(this.mibLetterDate);
                }
                this.realEstate.landCapitalization = {
                    financingRate: this.calculated.financingRate,
                    taxPerHectare: this.calculated.taxPerHectare,
                    calculatedTotalPrice: this.calculated.calculatedTotalLandPrice
                };

                this.realEstate.financingRate = this.financingRate;
                this.$http.post('admin/real-estate', this.realEstate)
                    .then(res => {
                        this.processing = false;
                        if (res.data.status !== "SUCCESS") {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t(res.data.message),
                                type: 'warning'
                            });
                            return;
                        }

                        if ('land' === action) {
                            this.$router.push('/real-estate/land/' + res.data.data.id);
                        } else if ('coordination' === action) {
                            this.$router.push('/real-estate/coordination/' + res.data.data.id + '/' + false);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.success'),
                                type: 'success'
                            });
                            if (this.realEstate.category === 'Residential'){
                                this.$router.push('/real-estate/residential');
                            } else {
                                this.$router.push('/real-estate/notorious');
                            }

                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            saveContractAmountByAgreement() {
                const saveData = {
                    id: this.realEstate.id,
                    contractAmountByAgreement: this.realEstate.contractAmountByAgreement,
                    contractAmountByAgreementDescription: this.realEstate.contractAmountByAgreementDescription
                };
                this.$http.post('admin/real-estate-contract-amount-agreement', saveData)
                    .then(res => {
                        console.log(res);
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.realEstate.success'),
                            type: 'success'
                        });
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            sendReportToMIBRealEstate: function () {
                this.processing = true;
                this.$http.get('/sendApiMibConfirmReport/pdf/' + this.realEstate.id + '/WITH_QR_CODE/Building', {responseType: 'arraybuffer'})
                    .then(response => {
                        if (response && response.status ===200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('realEstate.report.titleQrCode'),
                                type: 'success'
                            });
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.error'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('messages.common.error'),
                            type: 'warning'
                        });
                        this.processing = false;
                    })
            },
            changeStatus(status) {
                this.$http.get('contractRegion/check-contract/' + this.realEstate.id + "/Building").then(response => {
                    if (response.data.status !== 'SUCCESS' || response.data.status === 'SUCCESS' && response.data.code === 'ALLOWED') {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: response.data.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#dd3333',
                            confirmButtonText: 'Давом этиш',
                            cancelButtonText: 'Бекор қилиш'
                        }).then((result) => {
                            if (result.value) {
                                if (status === 'Evaluated' && !this.realEstate.approachRegression) {
                                    this.$router.push('/real-estate/coordination/' + this.realEstate.id + '/' + true);
                                } else this.changeStatusGo(status);
                            }
                        });
                    } else {
                        if (status === 'Evaluated' && !this.realEstate.approachRegression) {
                            this.$router.push('/real-estate/coordination/' + this.realEstate.id + '/' + true);
                        } else this.changeStatusGo(status);
                    }
                });
            },
            changeStatusGo(status) {
                const vm = this;
                this.processing = true;
                this.$http.post('admin/real-estate/status', {
                    realEstateId: this.realEstate.id,
                    status: status,
                }).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.$swal({
                            title: this.$root.$t('messages.common.success'),
                            text: this.$root.$t('messages.realEstate.statusSuccess'),
                            type: 'success'
                        });
                        vm.realEstate.status = status;
                        if (status === 'Confirmed') {
                            if (this.realEstate.hasEsp) {
                                this.$router.push('/real-estate/esp/' + this.realEstate.id)
                            }
                        }
                        this.init()
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t(res.data.message),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                }, () => {
                    this.$swal({
                        title: this.$root.$t('messages.common.error'),
                        text: this.$root.$t('messages.realEstate.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                });
            },
            showDeleteBuildingDialog(building, index) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.building.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                    // cancelButtonColor: '#dd3333'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('real-estate/building/' + building.id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.building.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.realEstate.buildings.splice(index, 1);
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.building.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            // showDeletePaymentDialog(payment, index) {
            //     this.$swal({
            //         title: this.$t('messages.common.warning'),
            //         text: this.$t('messages.building.deleteConfirm'),
            //         type: 'warning',
            //         showCancelButton: true,
            //         confirmButtonColor: '#dd3333',
            //         confirmButtonText: 'Ўчириш',
            //         cancelButtonText: 'Бекор қилиш'
            //         // cancelButtonColor: '#dd3333'
            //     }).then((result) => {
            //         if (result.value) {
            //             this.$http.delete('real-estate/payment/' + payment.id)
            //                 .then((res) => {
            //                     if (res && res.data && res.data.status === 'SUCCESS') {
            //                         this.$swal({
            //                             title: this.$t('messages.common.success'),
            //                             text: this.$t('messages.building.deleteSuccess'),
            //                             type: 'success'
            //                         });
            //                         this.realEstate.payments.splice(index, 1);
            //                     } else {
            //                         this.$swal({
            //                             title: this.$t('messages.common.warning'),
            //                             text: res.data.message,
            //                             type: 'warning'
            //                         });
            //                     }
            //                     this.processing = false;
            //                 }, () => {
            //                     this.$swal({
            //                         title: this.$t('messages.common.error'),
            //                         text: this.$t('messages.building.deleteError'),
            //                         type: 'error'
            //                     });
            //                     this.processing = false;
            //                 });
            //         }
            //     });
            // },
            isGoalType(goalTypeCodes) {
                return !!(this.realEstate.evlGoalType && goalTypeCodes && goalTypeCodes.indexOf(this.realEstate.evlGoalType) >= 0);
            },
            initProvinceRegions() {
                let regions = [];
                if (this.realEstate.province && this.realEstate.province.id && this.realEstate.province.id > 0 && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.realEstate.province.id && province.regions && province.regions.length > 0) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
            },
            onProvinceChange() {
                this.initProvinceRegions();
                this.realEstate.region = {};
                if (this.realEstate.province.id > 0) {
                    this.initLandCapitalizationProvinceChangeData();
                }
            },
            onOwnerSearch(searchTxt, loading) {
                loading(true);
                this.owners = [];
                this.ownerFilter.search = searchTxt;
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onOwnerFocus() {
                this.owners = [];
                this.ownerFilter.search = '';
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerSearch(searchTxt, loading) {
                loading(true);
                this.customers = [];
                this.customerFilter.search = searchTxt;
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerFocus() {
                this.customers = [];
                this.customerFilter.search = '';
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            isEvlApproachConfirm() {
                return (this.realEstate.approachCost && (this.realEstate.approachComparative || this.realEstate.approachIncome));
            },
            reportPdf: function (realEstate) {

                this.isPdfLoading = true;

                // if (!this.isEvlApproachConfirm()) {
                //     this.isPdfLoading = false;
                //     return;
                // }

                this.$http.get('/v2/realEstateReport/pdf/' + realEstate.hashUuid + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: 'application/pdf'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Хисобот ' + realEstate.owner.fullName + '.pdf';
                        link.click();
                        this.isPdfLoading = false
                    })
                    .catch(err => {
                        console.log(err);
                        this.isPdfLoading = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.reportPdf(realEstate))
                        }
                    })
            },
            reportPdfQrCode: function (realEstate) {
                this.isPdfQrLoading = true;

                // if (!this.isEvlApproachConfirm()) {
                //     this.isPdfQrLoading = false;
                //     return;
                // }

                this.$http.get('/v2/realEstateReport/pdf/' + realEstate.hashUuid + '/WITH_QR_CODE', {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: 'application/pdf'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Хисобот ' + realEstate.owner.fullName + '.pdf';
                        link.click();
                        this.isPdfQrLoading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.isPdfQrLoading = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.reportPdfQrCode(realEstate))
                        }
                    })
            },
            reportDoc: function (realEstate) {

                this.isDocLoading = true;

                // if (!this.isEvlApproachConfirm()) {
                //     this.isDocLoading = false;
                //     return;
                // }

                this.$http.get('/v2/realEstateReport/doc/' + realEstate.hashUuid + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: 'application/doc'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Хисобот ' + realEstate.owner.fullName + '.doc';
                        link.click();
                        this.isDocLoading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.isDocLoading = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.reportDoc(realEstate))
                        }
                    })
            },
            reportDocQrCode: function (realEstate) {

                this.isDocQrLoading = true;

                // if (!this.isEvlApproachConfirm()) {
                //     this.isDocQrLoading = false;
                //     return;
                // }

                this.$http.get('/v2/realEstateReport/doc/' + realEstate.hashUuid + '/WITH_QR_CODE', {responseType: 'arraybuffer'})
                    .then(response => {

                        let blob = new Blob([response.data], {type: 'application/doc'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Хисобот ' + realEstate.owner.fullName + '.doc';
                        link.click();
                        this.isDocQrLoading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.isDocQrLoading = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.reportDocQrCode(realEstate))
                        }
                    })
            },
            reportContractDocQrCode: function (realEstate) {

                this.isCDocQrLoading = true;

                this.$http.get('/v2/realEstateContractReport/doc/' + realEstate.hashUuid + '/WITH_QR_CODE', {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: 'application/doc'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Шартнома ' + realEstate.owner.fullName + '.doc';
                        link.click();
                        this.isCDocQrLoading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.isCDocQrLoading = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.reportContractDocQrCode(realEstate))
                        }
                    })
            },
            reportContractDoc: function (realEstate) {

                this.isCDocLoading = true;

                this.$http.get('/v2/realEstateContractReport/doc/' + realEstate.hashUuid + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: 'application/doc'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Шартнома ' + realEstate.owner.fullName + '.doc';
                        link.click();
                        this.isCDocLoading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.isCDocLoading = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.reportContractDoc(realEstate))
                        }
                    })
            },
            reportContractPdf: function (realEstate) {
                this.isCPdfLoading = true;

                this.$http.get('/v2/realEstateContractReport/pdf/' + realEstate.hashUuid + '/WITH_SIGNATURE', {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: 'application/pdf'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Шартнома ' + realEstate.owner.fullName + '.pdf';
                        link.click();
                        this.isCPdfLoading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.isCPdfLoading = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.reportContractPdf(realEstate))
                        }
                    })
            },
            reportContractQrCodePdf: function (realEstate) {
                this.isCPdfQrLoading = true;

                this.$http.get('/v2/realEstateContractReport/pdf/' + realEstate.hashUuid + '/WITH_QR_CODE', {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: 'application/pdf'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Шартнома ' + realEstate.owner.fullName + '.pdf';
                        link.click();
                        this.isCPdfQrLoading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.isCPdfQrLoading = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.reportContractQrCodePdf(realEstate))
                        }
                    })
            },
            showReport: function () {
                this.$http.post('admin/real-estate/show-report/' + this.realEstate.id + '/' + this.realEstate.displayReport)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showReportSuccess'),
                                type: 'success'
                            });
                            this.realEstate.status = status;
                        } else if (res && res.data && res.data.status === 'FAIL') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showCancelReportSuccess'),
                                type: 'success'
                            });
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.showReportError'),
                            type: 'error'
                        });
                    });
            },
            handleChangeLand: function (e) {
                const name = e.target.name;
                if (this.realEstate[name]) {
                    Object.keys(this.realEstate).map((key) => {
                        if (key != name) {
                            if (key === 'landComparisonEnabled' || key === 'landCapitalizationEnabled') {
                                this.realEstate[key] = false;
                            }
                        }
                    })
                }
            },
            onRegionChange() {
                if (this.realEstate.region.id > 0) {
                    this.initLandCapitalizationRegionChangeData()
                }
            },
            initLandCapitalizationProvinceChangeData() {
                const vm = this;
                this.$http.get('admin/real-estate/land-capitalization/province/' + this.realEstate.province.id)
                    .then(res => {
                        const data = res.data;
                        vm.initLandCapitalizationData(data)
                    }, err => {
                        console.log(err);
                    });
            },
            initLandCapitalizationRegionChangeData() {
                const vm = this;
                this.$http.get('admin/real-estate/land-capitalization/region/' + this.realEstate.region.id)
                    .then(res => {
                        const data = res.data;
                        vm.initLandCapitalizationData(data)
                    }, err => {
                        console.log(err);
                    });
            },
            initLandCapitalizationData(data) {
                this.financingRate = data.financingRate;
                this.taxPerHectare = data.taxPerHectare;
            },
            onChangeApproach(value, $event) {
                const checked = $event.target.checked;
                if (checked && value === 'Regression')  {
                    this.realEstate.approachCost = false;
                    this.realEstate.approachIncome = false;
                    this.realEstate.approachComparative = false;
                }
                if (!checked && value === 'Regression') {
                    this.realEstate.approachCost = true;
                }
                if (checked && value === 'Income') {
                    this.realEstate.approachRegression = false;
                }

                if (checked && value === 'Comparative') {
                    this.realEstate.approachRegression = false;
                }

                if (checked && value === 'Cost') {
                    this.realEstate.approachRegression = false;
                }
            },
            calculateApproachTotal(building) {
                let approachTotalPrice = 0;
                if (building.calculated && building.calculated.price && building.calculated.price.expense && this.realEstate.approachCost) {
                    approachTotalPrice = approachTotalPrice + building.calculated.price.expense;
                }
                if (building.comparison && building.comparison.calculatedTotalPrice && this.realEstate.approachComparative) {
                    approachTotalPrice = approachTotalPrice + building.comparison.calculatedTotalPrice;
                }
                if (building.comparisonIncome && building.comparisonIncome.calculated && building.comparisonIncome.calculated.total && this.realEstate.approachIncome) {
                    approachTotalPrice = approachTotalPrice + building.comparisonIncome.calculated.total;
                }
                if (building.comparisonRegression && building.comparisonRegression.totalPrice && this.realEstate.approachRegression) {
                    approachTotalPrice = approachTotalPrice + building.comparisonRegression.totalPrice;
                }
                return approachTotalPrice;
            },
            // async onCadastreSec
            // tionSearch({ action/*, searchQuery, callback*/ }) {
            //     console.log(action);
            //     this.cadastreSections = [];
            //     this.cadastreSectionFilter.search = '';
            //     this.$http.post('cadastre/section/search', this.cadastreSectionFilter)
            //         .then(res => {
            //             this.cadastreSections = res.data.data.map((item) => {
            //                 item.label = item.name;
            //                 return item;
            //             });
            //         }, (err) => {
            //             console.log(err);
            //             this.cadastreSections = null;
            //         });
            // }
            getEvaluationRespectiveType() {
                this.$http.get('/evaluationRespectiveType').then(response => {
                    this.evaluationRespectiveTypes = response.data;
                },err => {
                    console.log(err)
                });
            },

            getGenericEncryptUrl(realEstate) {
                this.$http.get('esign/' + realEstate.id)
                    .then(res => {
                        if (res.data.status !== 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#dd3333',
                                confirmButtonText: 'Давом этиш',
                                cancelButtonText: 'Бекор қилиш'
                            });
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('Xatlik!'),
                                type: 'warning'
                            });
                        }
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.cadastreSectionFilter.page.size = 10000;
            this.init();
            this.getEvaluationRespectiveType();
        }
    }
</script>

<style scoped>

</style>
